var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsTrophyOrangeBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8133 55.4688H22.1883M48.8133 55.4688C53.7148 55.4688 57.6883 59.4422 57.6883 64.3438H13.3133C13.3133 59.4422 17.2867 55.4688 22.1883 55.4688M48.8133 55.4688V45.4844C48.8133 43.6463 47.3232 42.1562 45.4851 42.1562H42.9066M22.1883 55.4688V45.4844C22.1883 43.6463 23.6783 42.1562 25.5164 42.1562H28.095M42.9066 42.1562H28.095M42.9066 42.1562C41.2874 39.3572 40.2621 36.1715 40.0031 32.7716M28.095 42.1562C29.7142 39.3572 30.7394 36.1715 30.9984 32.7716M15.532 12.5326C12.626 12.9551 9.74952 13.4686 6.90543 14.0699C8.2376 21.9612 14.7774 28.0829 22.8676 28.7779M15.532 12.5326V13.3125C15.532 19.548 18.3901 25.116 22.8676 28.7779M15.532 12.5326V8.04931C22.0564 7.13109 28.7231 6.65625 35.5008 6.65625C42.2784 6.65625 48.9451 7.13109 55.4695 8.04931V12.5326M22.8676 28.7779C25.1976 30.6834 27.966 32.0728 30.9984 32.7716M55.4695 12.5326V13.3125C55.4695 19.548 52.6115 25.116 48.1339 28.7779M55.4695 12.5326C58.3755 12.9551 61.252 13.4686 64.0961 14.0699C62.764 21.9612 56.2241 28.0829 48.1339 28.7779M48.1339 28.7779C45.804 30.6834 43.0355 32.0728 40.0031 32.7716M40.0031 32.7716C38.5561 33.105 37.049 33.2812 35.5008 33.2812C33.9525 33.2812 32.4454 33.105 30.9984 32.7716",
    stroke: "#FBBC55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsTrophyOrangeBig);
export default __webpack_public_path__ + "static/media/es_trophy_orange_big.21ee11b8062dd041a00bfc1a2582a6b6.svg";
export { ForwardRef as ReactComponent };